/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-02-03 14:00:19
 * @Description: 
 */
import { Input } from "antd";
import React from "react";
import { IconArrawDown, IconClose } from "src/assets";
import { useEffectSelectTags, useEffectTags } from "src/hooks";
import clsx from "clsx"
import "./ToolLeftSearchTags.scss"
import FTImageStore from "src/store/FTImageStore";
import FTAnalytic from "src/analyze/FTAnalytic";

export default function ToolLeftSearchTags() {
  let effectTags = useEffectTags()
  let selectTags = useEffectSelectTags()
  let [effectTagsList, setEffectTagsList]= React.useState<any>([])
  let [expend, setExpend] = React.useState(false)

  React.useEffect(() => {
    if(expend) {
      setEffectTagsList(effectTags)
    } else {
      setEffectTagsList(effectTags.slice(0, 6))
    }
  }, [effectTags, expend])

  const handleChooseTags = (tag: any) => {
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$click_up$goart_project_effects',
      label: {
        resource_id: tag,
        resource_name: tag,
      }
    })
    FTImageStore.addSelectTags(tag)
  }
  return <div className="search_tags">
    {
      effectTagsList.map((item: any) => {
        return <span key={item} className={clsx("search_tags_item", selectTags.indexOf(item) !== -1 && "active")} onClick={() => handleChooseTags(item)}>
          { item }
        </span>
      })
    }
    <div className={clsx("search_tags_more", expend && "expend")} onClick={() => setExpend(x => !x)}>
      <IconArrawDown />
    </div>
  </div>
}